<template>
  <v-snackbar
      :timeout="-1"
      top
      :value="needReloadPage"
      multi-line
      vertical
      :dark="$vuetify.theme.dark"
      class="relevance-snackbar">
    <div>
      {{ $t('Вышла новая версия сайта. Для загрузки обновлений необходимо принудительно обновить страницу, используя комбинацию клавиш Ctrl + F5, либо нажав кнопку:') }}
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn
          text
          :dark="$vuetify.theme.dark"
          v-bind="attrs"
          class="red mr-2"
          @click="reload">
        {{ $t('Обновить') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<style scoped>
  .relevance-snackbar::v-deep .red {
    color: var(--v-error-base)!important;
  }
  .relevance-snackbar::v-deep .v-snack__content {
    width: 100% !important;
  }
 </style>

<script>
  import { RELEVANCE_INTERVAL } from '@/constants/settings'
  import { mapState, mapActions } from 'vuex'
  import { RELEVANCE } from '@/constants/store.js'
  export default {
    name: 'Relevance',
    data () {
      return {
        intervalId: null
      }
    },
    computed: {
      ...mapState(RELEVANCE.NAMESPACE, {
        reloadPage: RELEVANCE.STATE.NEED_RELOAD_PAGE
      }),
      needReloadPage () {
        if (this.reloadPage && this.intervalId) {
          clearInterval(this.intervalId)
        }

        return this.reloadPage
      }
    },
    created () {
      const vm = this
      vm.checkRelevanceAction().then(() => {
        vm.intervalId = setInterval(vm.checkRelevanceAction, RELEVANCE_INTERVAL)
      })
    },
    beforeDestroy () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
    },
    methods: {
      ...mapActions(RELEVANCE.NAMESPACE, {
        checkRelevanceAction: RELEVANCE.ACTIONS.CHECK_RELEVANCE
      }),
      reload: function () {
        window.location.reload(true)
      }
    }
  }
</script>
